import { Outlet } from 'react-router-dom';
import TopNav from './TopNav';

export default function AppShell() {
  return (
    <div className="app-shell">
      <TopNav />
      <main className="app-shell__content">
        <Outlet />
      </main>
    </div>
  );
}
